module.exports = __webpack_public_path__ + "img/VS.924039a.svg";